export function getLogoUrl(options) {
  if (!options || typeof options.themeId !== 'string' || !options.themeId) {
    return null;
  }
  const themeId = options.themeId;

  if (themeId.includes('brandwatch')) {
    return 'https://cdn.vizia.brandwatch.com/assets/theme-logos/logo-mark.svg';
  }

  return new URL(`/${themeId}/img/shareable-logo.svg`, window.env.THEMES_URL).href;
}
